import type { Device } from "./types";

export type DeviceState = "disabled" | "online" | "offline";

/** Máy được coi là online nếu vừa liên lạc trong ngưỡng này. */
export const ONLINE_THRESHOLD_MINUTES = 15;

export function deviceState(
  device: Device,
  thresholdMinutes = ONLINE_THRESHOLD_MINUTES,
): DeviceState {
  if (device.disabled) return "disabled";
  if (!device.lastSeenAt) return "offline";
  const last = new Date(device.lastSeenAt).getTime();
  if (Number.isNaN(last)) return "offline";
  return Date.now() - last < thresholdMinutes * 60_000 ? "online" : "offline";
}
